<template>
  <div>
    <el-switch
       v-model="mode"
       active-value="basic"
       active-text="Basique"
       inactive-value="advanced"
       inactive-text="Avancé" />
    <div v-if="mode === 'basic'" >
      <div class="row" >
        <div class="title" >Couleur du Widget</div>
        <el-color-picker v-model="basic.color" />
      </div>
    </div>
    <el-collapse v-else v-model="activeName" :accordion="true" >
      <el-collapse-item v-for="(s, i) in style" :name="'item-' + i" :key="'item-' + i" >
        <template slot="title" >
          <div class="title" >{{ s.title }}</div>
          <el-checkbox v-model="s.enabled" ></el-checkbox>
        </template>
        <div v-for="(value, j) in s.values" :key="'item-' + i + '-value-' + j" >
          <div v-if="typeof value.type === 'undefined' || value.type === 'size'" >
            <div class="row" >
              <div class="title" >{{ value.title }}</div>
              <el-input v-model="value.value" ></el-input>
              <div>px</div>
            </div>
            <div class="row">
              <el-slider
                 v-model="value.value"
                 :min="d(value.min, -50)"
                 :max="d(value.max, 50)" >
              </el-slider>
            </div>
          </div><!-- size -->
          <div v-else-if="value.type === 'choice'" >
            <div class="row">
              <div class="title" >{{ value.title }}</div>
              <el-select v-model="value.value" >
                <el-option
                   v-for="choice in value.choices"
                   :key="'item-' + i + '-value-' + j + '-' + choice.value"
                   :label="choice.label"
                   :value="choice.value" >
                </el-option>
              </el-select>
            </div>
          </div><!-- choice -->
          <div v-else >
            <div class="row" >
              <div class="title" >{{ value.title }}</div>
              <el-color-picker
                 v-model="value.value"
                 :show-alpha="true"
                 @active-change="v => { value.value = v }" >
              </el-color-picker>
            </div>
          </div><!-- color -->
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="actions" >
      <el-button type="warning" @click="cancel" >Annuler</el-button>
      <el-button type="success" @click="save" >Valider</el-button>
    </div>
  </div>
</template>

<style scoped>
.el-collapse >>> .el-collapse-item__header {
    display: flex;
    align-items: center;
    justify-content: center;
}
.el-collapse .title {
    flex: 1;
}
.el-collapse .el-checkbox {
    padding: 0 10px;
}
.el-slider >>> .el-slider__bar {
    opacity: 0;
}
.el-slider {
    flex: 1;
}
.row {
    display: flex;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 5px;
    margin-bottom: 5px;
}
.row div {
    display: flex;
    align-items: center;
}
.row .title {
    flex: 1;
    white-space: nowrap;
}
.row .el-input {
    max-width: 50px;
}
.actions {
    text-align: right;
    margin-top: 5px;
}
</style>

<script>
import {api} from 'macarons'

const d = (value, defaultValue) => {
  return typeof value === 'undefined' ? defaultValue : value
}

export default {
  props: {
    value: {
      required: true,
      type: Object
    },
    widget: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      mode: 'basic',
      basic: {
        color: null
      },
      activeName: '',
      showTitle: true,
      style: [
        {
          title: 'Ombre',
          enabled: true,
          properties: ['box-shadow'],
          values: [
            {
              title: 'Longueur Horizontale',
              value: 0
            },
            {
              title: 'Longueur Verticale',
              value: 0
            },
            {
              title: 'Diamètre du flou',
              value: 0,
              min: 0
            },
            {
              title: 'Diamètre de l\'étalement',
              value: 0
            },
            {
              title: 'Couleur',
              type: 'color',
              value: null
            }
          ]
        },
        {
          title: 'Bordure',
          enabled: true,
          properties: ['border', 'border-radius'],
          values: [
            {
              title: 'Épaisseur',
              value: 0,
              min: 0
            },
            {
              title: 'Type de Bordure',
              type: 'choice',
              choices: [
                {label: 'Pleine', value: 'solid'},
                {label: 'Pointillés', value: 'dotted'},
                {label: 'Tirets', value: 'dashed'},
                {label: 'Double', value: 'double'},
                {label: 'Groove', value: 'groove'},
                {label: 'Rainure', value: 'riged'},
                {label: 'Intérieure', value: 'inset'},
                {label: 'Extérieure', value: 'outset'}
              ],
              value: 'solid'
            },
            {
              title: 'Couleur',
              type: 'color',
              value: null
            },
            {
              title: 'Arrondis',
              property: 'border-radius',
              value: 0,
              min: 0
            }
          ]
        },
        {
          title: 'Couleurs',
          enabled: true,
          properties: ['background-color'],
          values: [
            {
              title: 'Couleur du fond',
              value: null,
              type: 'color'
            }
          ]
        },
        {
          title: 'Titre',
          enabled: true,
          properties: ['background-color', 'color', 'font-size', 'text-align'],
          group: 'headerStyle',
          values: [
            {
              title: 'Couleur du fond',
              value: null,
              type: 'color'
            },
            {
              title: 'Couleur de la police',
              value: null,
              type: 'color',
              property: 'color'
            },
            {
              title: 'Taille de la police',
              value: 12,
              min: 8,
              max: 40,
              property: 'font-size'
            },
            {
              title: 'Alignement',
              value: 'left',
              type: 'choice',
              property: 'text-align',
              choices: [
                {label: 'Gauche', value: 'left'},
                {label: 'Centre', value: 'center'},
                {label: 'Droite', value: 'right'}
              ]
            }
          ]
        }
      ]
    }
  },
  watch: {
    mode () {
      this.handleChange()
    },
    basic () {
      this.handleChange()
    }
  },
  mounted () {
    this.$watch('style', () => {
      this.handleChange()
    }, {deep: true})
    this.$watch('basic', () => {
      this.handleChange()
    }, {deep: true})
    this.parseStyle()
  },
  methods: {
    parseStyle (options) {
      options = d(options, this.value)
      this.basic = Object.assign({color: '#2F4050'}, options.basic || {})
      this.mode = options.mode || 'basic'
      this.showTitle = options.showTitle
      this.style.forEach(s => {
        s.enabled = s.properties.some(
          p => typeof options[d(s.group, 'style')] !== 'undefined' &&
            typeof options[d(s.group, 'style')][p] !== 'undefined'
        )
        if (s.enabled) {
          s.properties.forEach(p => {
            if (typeof options[d(s.group, 'style')][p] !== 'undefined') {
              const fragments = options[d(s.group, 'style')][p].split(' ')
              s.values.filter(v => {
                return d(v.property, s.properties[0]) === p
              }).forEach((v, i) => {
                if (typeof v.type === 'undefined' || v.type === 'size') {
                  v.value = parseInt(fragments[i].replace('px', ''))
                } else {
                  v.value = fragments[i]
                }
              })
            }
          })
        }
      })
    },
    handleChange (emit) {
      const options = {
        style: {},
        showTitle: this.showTitle,
        mode: this.mode,
        basic: Object.assign({}, this.basic)
      }
      this.style.forEach(s => {
        if (typeof s.group !== 'undefined' && typeof options[s.group] === 'undefined') {
          options[s.group] = {}
        }
        if (s.enabled) {
          s.properties.forEach(p => {
            options[d(s.group, 'style')][p] = s.values.filter(v => {
              return d(v.property, s.properties[0]) === p
            }).map(v => {
              if (v.value === null) {
                return null
              }
              if (typeof v.type === 'undefined' || v.type === 'size') {
                return v.value + 'px'
              }
              return v.value.replace(/\s+/g, '')
            }).join(' ')
          })
        }
      })
      if (typeof emit === 'undefined' || emit) {
        this.$emit('input', options)
      }
      return options
    },
    cancel () {
      api.get('widget/' + this.widget + '/style').then(({data}) => {
        this.parseStyle(data.style)
        this.handleChange()
      }).catch(() => {
        const options = {
          style: {},
          showTitle: true
        }
        this.style.forEach(s => {
          if (typeof s.group !== 'undefined' && typeof options[s.group] === 'undefined') {
            options[s.group] = {}
          }
        })
        this.$emit('input', options)
      }).finally(() => {
        this.$parent.$emit('discard')
      })
    },
    save () {
      api.post('widget/' + this.widget + '/style', this.handleChange(false)).then(() => {
        this.$message({
          type: 'success',
          message: 'Style du Widget Sauvegardé'
        })
        this.$parent.$emit('discard')
      }).catch(() => {
        this.$message({
          type: 'error',
          message: 'Une erreur est survenue pendant la sauvegarde'
        })
      })
    },
    d: d
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/style-box/StyleBox.vue